export enum HrCodeCategories {
  Leave = "leave",
  Absence = "absence",
  GeneralLeave = "general_leave",
  Availability = "availability",
}

export interface HrCode {
  id: number
  practice_id: string
  category: HrCodeCategories
  code: string
  title: string
  order: number
  deletable: boolean
  disabled: boolean
}
